<template>
  <OrganizationList :organizations="mediaOwners" />
</template>

<script setup lang="ts">
  import { computed, onBeforeMount } from 'vue';

  import OrganizationList from '@/common/components/organization/OrganizationList.vue';
  import { useMediaOwners } from '@/org-app/services/tanstack/queries';
  import { waitForPendingQueries } from '@/org-app/services/tanstack/queryUtils';

  interface IProps {
    ids: number[];
    maxMediaOwnersDisplayed?: number;
  }

  const props = withDefaults(defineProps<IProps>(), { maxMediaOwnersDisplayed: 5 });

  const mediaOwnersQuery = useMediaOwners();

  const mediaOwners = computed(() =>
    mediaOwnersQuery.items.value.filter((x) => props.ids.includes(x.id)).sort((a, b) => a.name.localeCompare(b.name)),
  );

  onBeforeMount(async () => {
    await waitForPendingQueries([mediaOwnersQuery]);
  });
</script>
